import "./DataGrid.scss";
import * as React from "react";
import { NoData, NoSearchResults, Checkbox } from "./";
import { DataGridPro as MaterialDataGrid, DataGridProProps as MaterialDataGridProps, GridOverlay, GridActionsCellItem, GridRenderCellParams, GridValueFormatter, GridEditInputCell } from "@mui/x-data-grid-pro";
import { getDataProps, type WithDataProps } from "../../shared/utilities";
import clsx from "clsx";


const NoDataOverlay = (props: any) => <GridOverlay {...props}><NoData title="No Data" description="No Rows To Show Here" /></GridOverlay>;
const NoSearchResultsOverlay = (props: any) => <GridOverlay {...props}><NoSearchResults title="Not Found" description="No Rows Matching Search Criteria" /></GridOverlay>;
const CheckboxControl = React.forwardRef((props: any, ref) => <Checkbox ref={ref} {...props} color="default" />);

type DataGridProps = MaterialDataGridProps & {
    slotProps?: MaterialDataGridProps["slotProps"] & {
        footer?: {
            hideExportToExcel?: boolean;
            additionalFooterItems?: React.ReactNode;
        }
    }
    disableSelectionOnClick?: boolean;
}


const DataGrid: React.FunctionComponent<WithDataProps<DataGridProps>> = (props: WithDataProps<DataGridProps>) => {
    const { slots, className, disableSelectionOnClick, disableRowSelectionOnClick, ...rest } = props;

    return <div className={clsx("DataGrid-container", className)} {...getDataProps(props)}>
        <MaterialDataGrid
            slots={{
                noRowsOverlay: NoDataOverlay,
                noResultsOverlay: NoSearchResultsOverlay,
                baseCheckbox: CheckboxControl,
                ...slots
            }}
            // backwards compatibility for older prop name...
            disableRowSelectionOnClick={disableSelectionOnClick ?? disableRowSelectionOnClick}
            {...rest}
        />
    </div>
};

export { DataGrid, GridActionsCellItem, GridEditInputCell };
export type { DataGridProps, GridRenderCellParams, GridValueFormatter };